import { motion } from 'framer-motion';
import { useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';
import Moon from '@/shared/ui/icons/Moon';
import Sun from '@/shared/ui/icons/Sun';

export default function ThemeSwitch() {
  const { darkTheme, toggleTheme } = useTheme();

  const sun = useMemo(
    () => (darkTheme ? { right: 10, opacity: 0 } : { right: -7, opacity: 1 }),
    [darkTheme]
  );

  const moon = useMemo(
    () => (darkTheme ? { left: -4, opacity: 1 } : { left: 12, opacity: 0 }),
    [darkTheme]
  );

  const bg = useMemo(() => (darkTheme ? '#FFFFFF3D' : '#F6F8FF'), [darkTheme]);

  return (
    <motion.button
      initial={{ backgroundColor: '#F6F8FF' }}
      animate={{ backgroundColor: bg }}
      onClick={toggleTheme}
      className="flex h-5 w-9 rounded-full p-1"
    >
      <div className="relative h-full w-full">
        <motion.div
          initial={{ right: -8, opacity: 1 }}
          animate={sun}
          className="absolute -top-1 flex h-6 w-6 items-center"
        >
          <Sun />
        </motion.div>
        <motion.div
          initial={{ left: -4, opacity: 1 }}
          animate={moon}
          className="absolute -top-0.5 flex h-6 w-6 items-center"
        >
          <Moon />
        </motion.div>
      </div>
    </motion.button>
  );
}
